"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultCustomRouteDefinitions = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DefaultCustomRouteDefinitions = exports.DefaultCustomRouteDefinitions = [{
  label: 'After Payment',
  customContent: null,
  customCssClass: '',
  id: 'step6',
  url: '/step6',
  componentKey: 'PaymentSuccess'
}, {
  label: 'Success',
  customContent: null,
  customCssClass: '',
  id: 'success',
  url: '/success',
  componentKey: 'PaymentSuccess'
}, {
  label: 'Error',
  customElements: null,
  customCssClass: '',
  id: 'error',
  url: '/error',
  componentKey: 'ErrorPage'
}, {
  label: 'QuoteRetrieve',
  customElements: null,
  customCssClass: '',
  id: 'quoteRetrieve',
  url: '/cust/quoteretrieve/:id',
  componentKey: 'CustomerQuoteRetrieve'
}];